import { FilterTypeEnum } from "../../components/enums/FilterTypeEnum";
import { typedAction } from "../helpers";
import { SearchState } from "../models/reduxModels";
import { SET_IS_IN_SEARCH_MODE, SET_SEARCH, SET_SEARCH_FILTER_TYPE } from "./actionTypes";

const initialState: SearchState = { searchValue: { value: "", filterType: "" }, isInSearchMode: false };

export const setSearch = (value: string) => {
  return typedAction(SET_SEARCH, value?.trim());
};

export const setIsInSearchMode = (isInSearchMode: boolean) => {
  return typedAction(SET_IS_IN_SEARCH_MODE, isInSearchMode);
};

export const setSearchFilterType = (searchFilterType: FilterTypeEnum | "") => {
  return typedAction(SET_SEARCH_FILTER_TYPE, searchFilterType);
};

type SharepointInfoAction = ReturnType<typeof setSearch | typeof setIsInSearchMode | typeof setSearchFilterType>;

export function searchReducer(state = initialState, action: SharepointInfoAction): SearchState {
  switch (action.type) {
    case SET_SEARCH:
      return { ...state, searchValue: { ...state.searchValue, value: action.payload } };
    case SET_IS_IN_SEARCH_MODE:
      return { ...state, isInSearchMode: action.payload };
    case SET_SEARCH_FILTER_TYPE:
      return { ...state, searchValue: { ...state.searchValue, filterType: action.payload } }
    default:
      return state;
  }
}
